// CupLineupLab.jsx
import NascarLineupLab from "./NascarLineupLab";

export default function CupLineupLab() {
  return <NascarLineupLab series="cup" />;
}